import { ref, watch } from 'vue';
import { useUserStore } from '/@/store/modules/user';
import { NEW_FEATURE_NOTIFICATION_KEY } from '/@/enums/cacheEnum';

export function useNewFeatureNotification() {
  const visible = ref(false);
  // 是否使用新功能介绍
  const useNewFeatureNotification = ref(false);
  // 检查是否应该显示新功能提醒
  const shouldShowNotification = (): boolean => {
    if (useNewFeatureNotification.value) {
      const userStore = useUserStore();
      const userId = userStore.getUserInfo?.id;
      const token = userStore.getToken;
      
      if (!userId || !token) {
        return false; // 如果没有用户ID，不显示提醒
      }
      
      // 使用用户ID来区分不同用户的设置
      const storageKey = `${NEW_FEATURE_NOTIFICATION_KEY}${userId}`;
      const hasClosed = localStorage.getItem(storageKey);
      return !hasClosed;
    } else {
      return false;
    }
  };
  
  // 显示新功能提醒
  const showNewFeatureNotification = () => {
    visible.value = shouldShowNotification()
  };
  
  // 关闭新功能提醒
  const closeNewFeatureNotification = () => {
    visible.value = false;
  };
  
  // 监听用户信息变化
  const userStore = useUserStore();
  
  // 监听用户信息是否已加载且有效
  watch(
    () => userStore.getUserInfo,
    (newUserInfo) => {
      // 当用户信息发生变化且有效时，检查是否显示新功能提醒
      setTimeout(() => {
        showNewFeatureNotification();
      }, 1000);
    },
    { immediate: true, deep: true }
  );
  
  return {
    visible,
    showNewFeatureNotification,
    closeNewFeatureNotification,
    shouldShowNotification
  };
}